<template>
  <div>
    <div class="upload-type" :style="{ background: $vuetify.theme.themes.light.soft }" @click="openSelectFile()">
      <v-img class="mx-2" src="@/assets/upload-icon.png" max-width="100" width="70px" contain></v-img>
      <div class="d-flex flex-column">
        <div class="title">
          {{ arquivo ? 'Substituir o arquivo' : 'Enviar um arquivo' }}
        </div>
        <div v-if="arquivo">
          Você enviou um arquivo. Clique aqui para substituir o arquivo enviado
        </div>
        <div v-else>
          Clique aqui para enviar o arquivo do seu atestado (png, jpg ou pdf).<br />
          <span class="hint">Tamanho máximo do arquivo: 3Mb</span>
        </div>
      </div>
      <input
        type="file"
        id="file-upload"
        hidden
        accept="image/png, image/jpeg, .pdf"
        ref="file"
        @input="fileUploaded()"
      />
    </div>
    <v-alert type="warning" :value="showExtensionError">
      O arquivo que você escolheu é diferente dos permitidos, somente (png, jpg ou pdf)
    </v-alert>
    <v-alert type="warning" :value="showFileSizeError">
      O arquivo que você escolheu é maior que o permitido (3 Mb)
    </v-alert>
    <!-- <div class="upload-type">
      <v-img class="mx-2" src="@/assets/logo.png" max-width="100" width="70px" contain></v-img>
      <div class="d-flex flex-column" @click="openCamera()">
        <div class="title">
          Tirar uma foto do atestado
        </div>
        <div v-if="arquivo">
          Você enviou um arquivo JPG, clique aqui para substituir o arquivo enviado
        </div>
        <div v-else>
          Clique aqui para abrir a sua câmara e tirar uma foto do seu atestado
        </div>
      </div>
      <input
        type="file"
        capture="camera"
        id="camera"
        hidden
        accept="image/png, image/jpeg, .pdf"
        ref="file"
        @input="fileUploaded()"
      />
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'UploadAtestado',
  props: {
    arquivo: {
      required: true
    }
  },
  data() {
    return {
      showExtensionError: false,
      showFileSizeError: false
    }
  },
  methods: {
    openSelectFile() {
      document.getElementById('file-upload').click()
    },
    openCamera() {
      document.getElementById('camera').click()
    },
    fileUploaded() {
      const file = this.$refs.file.files[0]
      const ext = file.type.split('/')[1]
      if (!['png', 'pdf', 'jpg', 'jpeg'].includes(ext)) {
        this.showExtensionError = true
      } else if ((Math.round(+file.size / 1024) / 1000).toFixed(2) > 3) {
        this.showFileSizeError = true
      } else {
        this.$emit('file-uploaded', this.$refs.file.files[0])
      }
    }
  }
}
</script>

<style scoped>
.upload-type {
  display: flex;
  flex-direction: row;
  padding: 10px;
  font-size: 0.85rem;
  cursor: pointer;
  margin-bottom: 20px;
}
.title {
  font-size: 1.1rem !important;
}
.arquivo-adicionado {
  background: #f4f8fd;
  text-align: center;
  margin-top: 10px;
  color: #3e7cfe;
  text-decoration: underline;
}
.hint {
  font-size: 0.75rem;
  color: #616161;
}
</style>
